import { useEffect, useRef } from "react";
import { NavLink, Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import "./designPreview.css";

const LINKS = [
  { to: "/design-preview/capabilities", label: "Capabilities" },
  { to: "/design-preview/authority", label: "Authority" },
  { to: "/design-preview/guides", label: "Guides" },
  { to: "/design-preview/guide-detail", label: "Guide Detail" },
];

function useAmbientGlow(rootRef) {
  useEffect(() => {
    const el = rootRef.current;
    if (!el) return undefined;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    if (reduce || coarse) return undefined;
    let raf = null;
    const handle = (event) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        el.style.setProperty("--dp-glow-x", `${(event.clientX / window.innerWidth) * 100}%`);
        el.style.setProperty("--dp-glow-y", `${(event.clientY / window.innerHeight) * 100}%`);
        raf = null;
      });
    };
    window.addEventListener("pointermove", handle, { passive: true });
    return () => {
      window.removeEventListener("pointermove", handle);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [rootRef]);
}

export default function PreviewChrome() {
  const rootRef = useRef(null);
  useAmbientGlow(rootRef);

  return (
    <div className="dp-root" data-testid="design-preview" ref={rootRef}>
      <div className="dp-grain" aria-hidden="true" />
      <div className="dp-devbar">
        <span className="dp-devbar__mark">DEV DESIGN PREVIEW · 운영 페이지 아님</span>
        <nav aria-label="디자인 프리뷰">
          {LINKS.map((row) => (
            <NavLink key={row.to} to={row.to} className={({ isActive }) => (isActive ? "is-on" : "")}>
              {row.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}
